/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type HeaderRoot_viewer = {
    readonly geography?: {
        readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderData_geography">;
    } | null;
    readonly tradeFirms: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly profileStatus: DesignProfileStatus | null;
        readonly publicProfile: {
            readonly splashPhoto: string | null;
            readonly profilePhotoId: string | null;
            readonly designProjectsCount: number | null;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderBreadcrumbs_tradeFirm" | "ProfileHeaderData_tradeFirm" | "ProgressTour_tradeFirm">;
    } | null> | null;
    readonly " $refType": "HeaderRoot_viewer";
};
export type HeaderRoot_viewer$data = HeaderRoot_viewer;
export type HeaderRoot_viewer$key = {
    readonly " $data"?: HeaderRoot_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"HeaderRoot_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HeaderRoot_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isEditMode",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirms",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "urlLabel",
          "variableName": "firmUrlLabel"
        }
      ],
      "concreteType": "TradeFirmType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "profileStatus",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "publicProfile",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmPublicProfileType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "splashPhoto",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "profilePhotoId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "designProjectsCount",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "ProfileHeaderBreadcrumbs_tradeFirm",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "ProfileHeaderData_tradeFirm",
          "args": null
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isEditMode",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ProgressTour_tradeFirm",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isEditMode",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "geography",
          "storageKey": null,
          "args": null,
          "concreteType": "Geography",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "ProfileHeaderData_geography",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '12e32ef4d7352769eb0ced4cdbd84bb5';
export default node;
